<template>
  <!-- type 1  公司介绍 -->
  <!-- type 2  管理团队-->
  <!-- type 4  服务 -->
  <!-- type 5  资源中心 -->
  <!-- type 6  联系我们 -->
  <div v-if="navlist[type]">
    <div class="cur">
      <router-link to="/" tag="a">{{ $t("homeTxt") }}</router-link>
      &gt; <span>{{ navlist[type].name }}</span>
    </div>
    <ul class="ul-snv-r" v-if="navlist[type].sub">
      <li
        :class="[item.url == curpath ? 'on' : '']"
        v-for="(item, index) in this.$store.state.navlist[type].sub"
        :key="index"
      >
        <router-link tag="a" :to="item.url" class="v2" v-if="item.show">
          {{ item.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: ["type"],
  data () {
    return {
      curpath: ''
    }
  },
  created () {
    let that = this;
    let path = that.$route.path;
    if (path.split('/').length -1>1) {
      that.curpath = that.$route.path.slice(0,that.find(path,'/',1))
    }else{
      that.curpath = that.$route.path
    }
  },
  methods: {
    find(str,cha,num){
      let x=str.indexOf(cha);
      for(var i=0;i<num;i++){
        x=str.indexOf(cha,x+1);
      }
      return x;
    }
  },
  computed: mapState(['navlist']),

}
</script>

<style>
</style>